import { TextField } from "../components/TextField";
import type { TextFieldProps } from "../components/TextField";

export function getControllerTextFieldRender(props: TextFieldProps) {
  return ({ field }: any) => <TextField {...field} {...props} />;
}
